"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustmentComponent = void 0;
const core_1 = require("@angular/core");
const account_1 = require("./account");
const app_module_1 = require("./app.module");
const loading_service_1 = require("./loading.service");
const notification_service_1 = require("./notification.service");
const data_source_service_1 = require("./data-source.service");
const exchange_service_1 = require("./exchange.service");
const system_notification_service_1 = require("./system-notification.service");
const user_service_1 = require("./user.service");
const moment = require('moment');
let AdjustmentComponent = class AdjustmentComponent {
    constructor(_dataSource, _exchange, _notification, _user, _loading, _talk) {
        this._dataSource = _dataSource;
        this._exchange = _exchange;
        this._notification = _notification;
        this._user = _user;
        this._loading = _loading;
        this._talk = _talk;
        //constants
        this.DATA_SOURCE = 'connect';
        this.DATA_RANGE_LOWER_BOUND = '2019-08-01 00:00:00';
        this.searchTermObject = { val: '' };
        this.manualEntry = false;
        this.granularityDSP = true;
        this.downloadShell = true;
        // private selectedDate:any = moment({'year': 2019, 'month': 7, 'date':20}).startOf('day').format("MMMM Do YYYY"); //TODO:fix staging environment, remove hardcode
        this.selectedDate = moment().subtract(1, 'd').startOf('day').format("MMMM Do YYYY"); //TODO:fix staging environment, remove hardcode
        this.dateRangeOptions = {
            singleDatePicker: true,
            maxDate: moment().subtract(1, 'd').startOf('day')
        };
        this.selectedDsp = { txt: 'brealtime', val: '1', billingSource: 1 };
        this.dsps = [
            { txt: 'brealtime', val: '1', billingSource: 1 }
        ];
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.notifications();
            let startDate = this._dataSource.getSource(this.DATA_SOURCE).startTime ? this._dataSource.getSource(this.DATA_SOURCE).startTime : this.DATA_RANGE_LOWER_BOUND;
            this.dateRangeOptions.minDate = moment(startDate).startOf('day');
            account_1.Account.dspAsAccount = this.granularityDSP;
            this.pullDSPData();
            this.account = new account_1.Account();
            yield this.getAccounts();
        });
    }
    getAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            this._loading.start('Retrieving Helm Data...');
            this.accounts = (yield this.account.find({
                startTime: moment(this.selectedDate, "MMMM Do YYYY").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                endTime: moment(this.selectedDate, "MMMM Do YYYY").endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                interval: 'daily',
                bidder: this.selectedDsp.val,
                bidderName: this.selectedDsp.txt,
                bidderBillingSource: this.selectedDsp.billingSource,
                dspAsAccount: this.granularityDSP
            }));
            this._loading.stop();
            if (!this.accounts.length) {
                let talk = app_module_1.AppModule.injector.get(notification_service_1.NotificationService);
                talk.broadcast('No data for this time interval.');
            }
        });
    }
    inputChange(val) {
        this.searchTermObject.val = val;
    }
    setManualEntry(val) {
        return __awaiter(this, void 0, void 0, function* () {
            this.manualEntry = val;
            this.shouldPullUpdatedData();
        });
    }
    setDSP(val) {
        return __awaiter(this, void 0, void 0, function* () {
            this.granularityDSP = val;
            account_1.Account.dspAsAccount = val;
            this.searchTermObject = { val: '' };
            yield this.getAccounts();
        });
    }
    setDateRange(event) {
        this.selectedDate = moment(event.picker.startDate).format("MMMM Do YYYY");
        this.shouldPullUpdatedData();
    }
    isPreviousDay() {
        let startDate = this._dataSource.getSource(this.DATA_SOURCE).startTime ? this._dataSource.getSource(this.DATA_SOURCE).startTime : this.DATA_RANGE_LOWER_BOUND;
        return moment(startDate) < moment(this.selectedDate, "MMMM Do YYYY").subtract(1, 'days');
    }
    previousDay() {
        this.selectedDate = (moment(this.selectedDate, "MMMM Do YYYY").subtract(1, 'days')).format("MMMM Do YYYY");
        this.shouldPullUpdatedData();
    }
    isFollowingDay() {
        return moment(this.selectedDate, "MMMM Do YYYY").add(2, 'days') < moment();
    }
    followingDay() {
        this.selectedDate = moment(this.selectedDate, "MMMM Do YYYY").add(1, 'days').format("MMMM Do YYYY");
        this.shouldPullUpdatedData();
    }
    selectDsp(dsp) {
        this.selectedDsp = dsp;
        this.shouldPullUpdatedData();
    }
    pullDSPData() {
        return __awaiter(this, void 0, void 0, function* () {
            let bidderData = yield this._exchange.pullBidders();
            this.dsps = bidderData.map(bidder => { return { txt: bidder.name, val: bidder.id, status: bidder.status, billingSource: bidder.billingSource }; });
        });
    }
    shouldPullUpdatedData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.searchTermObject = { val: '' };
            if (this.manualEntry || this.granularityDSP) {
                yield this.getAccounts();
            }
            return [];
        });
    }
    // async toggleLoading() {
    //   let notifications = await this._notification.getNotifications('helmnotification', JSON.stringify({
    //     user: this._user.get().id,
    //   }));
    //   let json = await notifications.json();
    //   let loading = AppModule.injector.get(LoadingService);
    //   if (json.length) {
    //     loading.start();
    //   } else {
    //     loading.stop();
    //     this.clearHelmNotifications();
    //   }
    // }
    notifications() {
        return __awaiter(this, void 0, void 0, function* () {
            let submittingNotification = null;
            let processingNotifcation = null;
            this._notification.helmSubject.subscribe((notification) => __awaiter(this, void 0, void 0, function* () {
                if (notification) {
                    switch (notification.type) {
                        case "submitting":
                            this._loading.start('Processing Helm Changes');
                            submittingNotification = notification;
                            break;
                        case "processing":
                            processingNotifcation = notification;
                            break;
                        case "complete":
                            yield this.getAccounts();
                            this.clearNotification(submittingNotification);
                            this.clearNotification(processingNotifcation);
                            this.clearNotification(notification);
                            break;
                        case "failed":
                            yield this.getErrors(notification);
                            this._loading.stop();
                            this.clearNotification(submittingNotification);
                            this.clearNotification(processingNotifcation);
                            this.clearNotification(notification);
                            break;
                    }
                }
            }));
        });
    }
    getErrors(systemNotification) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let notification = yield systemNotification.fetch({ type: 'helmnotification' });
                let errors = notification.errors.join('<br>');
                this._talk.broadcast(errors);
            }
            catch (err) {
            }
        });
    }
    clearNotification(notification) {
        setTimeout(() => {
            console.log('calling clear notification');
            this._notification.deleteNotification(notification.id, 'helmnotification', true);
        }, 3000);
    }
};
exports.AdjustmentComponent = AdjustmentComponent;
exports.AdjustmentComponent = AdjustmentComponent = __decorate([
    (0, core_1.Component)({
        selector: 'adjustment-component',
        templateUrl: 'app/adjustment.component.html',
        styleUrls: ['styles/adjustment.component.css']
    }),
    __metadata("design:paramtypes", [data_source_service_1.DataSourceService,
        exchange_service_1.ExchangeService,
        system_notification_service_1.SystemNotificationService,
        user_service_1.UserService,
        loading_service_1.LoadingService,
        notification_service_1.NotificationService])
], AdjustmentComponent);
//# sourceMappingURL=adjustment.component.js.map